export default "__VITE_ASSET__GOKLVLiZ__"